var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270 513.4",
    style: {
      enableBackground: "new 0 0 270 513.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D0DE8E;}\n\t.st1{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:#F9DB00;}\n\t.st3{fill:#1F54B0;}\n\t.st4{fill:#D03632;}\n\t.st5{fill:#D1D1D1;}\n\t.st6{fill:#4C702B;}\n\t.st7{fill:#93B838;}\n\t.st8{fill:#B1CC40;}\n\t.st9{fill:#CAF741;}\n\t.st10{fill:#FEF7CE;}\n\t.st11{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.3,509.5c-0.3,2.4-2.5,4.1-4.9,3.8l-15.6-2c-2.4-0.3-4.1-2.5-3.8-4.9l10.5-80.3c0.3-2.4,2.5-4.1,4.9-3.8 c0,0,0,0,0,0l15.6,2c2.4,0.3,4.1,2.5,3.8,4.9L137.3,509.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.9,411.1c-0.3,2.4-2.5,4.1-4.9,3.7l-15.6-2.2c-2.4-0.3-4.1-2.5-3.7-4.9l2.7-19.5c0.3-2.4,2.5-4.1,4.9-3.7 c0,0,0,0,0,0l15.6,2.2c2.4,0.3,4.1,2.5,3.7,4.9c0,0,0,0,0,0L150.9,411.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,489c0,2.1-1.7,3.7-3.7,3.7c-2.1,0-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7l0,0 C134.4,485.3,136.1,487,136.1,489"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.6,462.4c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7 C137.9,458.7,139.6,460.4,139.6,462.4C139.6,462.4,139.6,462.4,139.6,462.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.5,435.4c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7 C141.8,431.6,143.5,433.3,143.5,435.4C143.5,435.3,143.5,435.3,143.5,435.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M148.8,400.6c0,2.1-1.7,3.7-3.7,3.7c-2.1,0-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7c0,0,0,0,0,0 C147.1,396.9,148.8,398.6,148.8,400.6L148.8,400.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M263.5,390.8l-53.8-91.8c-4.9,4.2-10.8,7.6-20.7,13.3c-8.8,5.1-20.8,12-38.4,23 c-34.5,21.8-68.1,43.1-68.4,43.3l-4-6.3c0.3-0.2,33.9-21.6,68.5-43.3c17.7-11.1,29.8-18.1,38.7-23.2c15.1-8.7,19.7-11.4,26.1-19.6 c9.9-14.4,11.5-16.7,23.2-79.1c5-45.3,1.2-68-6.6-90.1c-5.8-16.3-17.2-39.1-32.3-64.2s-29-48.7-29.1-49l6.5-3.8 c0.1,0.2,14,23.9,29.1,48.9c15.3,25.6,27,48.8,32.9,65.6c8.1,23.1,12.1,46.7,6.9,93.5v0.3c-11.6,61.8-13.5,66.2-24.5,82.2l-0.1,0.2 c-0.8,1-1.5,1.9-2.3,2.8L270,387L263.5,390.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M199.2,59.1c-7.2-11.8-12.6-21.2-15.6-25.9c-5.3-8.4-22.5-29.5-53.7-17.6s-37.7,38-39.2,59.6 c-0.3,35.1,7.4,82.6,12.1,97.6c8.7,28.1,7.6,118.5,64.9,115.9c49.6-2.2,49.8-71,47-85.2c-3.8-19.5,2-17.6,2-39.6 c0-28.2-14.7-34-9-55.8C212.7,89.7,207,71.9,199.2,59.1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M169.9,146.4c1.6,3.3,4.5,9.7,3.8,17.7c-1.2,14.2-6.5,22.9-1.7,58.5c3.4,24.7-1.7,35.8-12.8,36.9 c-8.6,0.9-17.2-6.5-21.4-17.2c-4.5-11.6-4.8-31.5-5.2-43.2c-0.4-11.1,1.7-37.5,3.9-51.2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M120.3,62.8c0.3-8.6,17.5-8.7,28.5-17.1c3.8-2.9,4.6-6.6,5.4-9.2c0.9-2.9,2.8-5.7,9.2-5.8 c15.9-0.3,8.5,24.1,12.4,40.5c1.7,7.3,6.4,8.1,6.1,16.8c-0.3,8.3-4.4,12.6-5.5,18.7c-2.1,11.4-4.7,12.9-9.7,20.7 c-3.5,5.5,1.4,15.3,2.2,17c9.3,18.4-3,21.3-13.9,21.4c-14.5,0.2-17.4-5.8-18.5-12.3c-1.4-8.5,6.1-25.7,8.4-32.4s1.9-15.5-0.6-18.6 c-4-4.9-6.7-3.2-13-7.9c-2.5-1.8-6.1-7.1-6.4-14C124.3,72,120,70.9,120.3,62.8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M155.7,47.4c16.3-0.5,16.1,13.4,17,21.4c0.6,5.8,4.1,11.5,3.9,20.6c-0.2,7.4-2.3,10-4.5,18.8 s-6.2,16.7-14.3,16.6c-4.1-0.2-9-2.6-8.4-12.3c1.4-22.8-12.2-9-11.6-40.5C138.1,60.1,143.2,47.8,155.7,47.4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M174.5,122.9c3.3-3,8.7,2,8.7,2s6,4.6,3.9,8.5c-1.7,3.1-3.8,3.2-6.2,4c-1.8,0.6-5.3,2.3-7.5,0.4 c-1.7-1.5-1.2-5.5-1.2-7.5S172.6,124.5,174.5,122.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M177.5,63.3c4-2.7,11.2,2.7,13.5,5.4c3,3.5,6.3,14,6,20.8c-0.4,8.9-3.2,9.7-3.1,14c0.2,5.7,3.6,13.1-1.5,13 c-6.2-0.1-7-2.7-8.6-11.2c-1.2-6.5-2.8-8.9-0.5-13.8c1.4-3,1.3-4.3,0.6-7.7c-1.3-7-4.3-3.2-6.5-10.7 C176.4,69.8,174.7,65.2,177.5,63.3"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M76.8,97.8c2.7-1.5,3.7-5,2.1-7.7c-0.8-1.4-2.2-2.4-3.8-2.8c0.8-1.7,0.8-3.7-0.1-5.3 c-1.5-2.7-4.9-3.7-7.6-2.3c0,0,0,0,0,0c-0.5,0.3-0.9,0.6-1.3,1c-2.5-1.8-6-1.2-7.8,1.4c-1.8,2.5-1.2,6,1.4,7.8 c0.7,0.5,1.6,0.8,2.4,1c-2,2.4-1.6,6,0.8,8c1.8,1.5,4.3,1.7,6.3,0.6c0.8-0.4,1.5-1.1,2-1.9C72.9,98.7,75,98.7,76.8,97.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M98.3,138.9c2.7,1.5,6.1,0.6,7.7-2.1c1.5-2.7,0.6-6.1-2.1-7.7c-0.9-0.5-1.8-0.7-2.8-0.7h-0.3 c-1.1-2.9-4.4-4.4-7.3-3.3c-2.2,0.8-3.7,3-3.7,5.3l0,0c-0.5-0.1-0.9-0.2-1.4-0.2c-1,0-2,0.3-2.8,0.8c-0.4-2.1-2-3.8-4.1-4.3 c0.2-0.6,0.4-1.3,0.4-1.9c-0.1-3.1-2.8-5.6-5.9-5.4c-2.9,0.1-5.3,2.5-5.4,5.4c0,1,0.3,2,0.8,2.8c-3,0.7-4.9,3.7-4.3,6.7 c0.6,2.6,2.9,4.4,5.5,4.4h0.1c0,1.2,0.4,2.4,1.2,3.4c-1.4,1-2.1,2.7-2.2,4.4c0,1.6,0.7,3.1,1.8,4.1c-0.5,0.8-0.8,1.8-0.8,2.8 c0,2,1.1,3.8,2.8,4.8c-1.4,2.4-0.9,5.4,1.3,7.1c-2.3,2-2.5,5.5-0.5,7.8c0.4,0.4,0.8,0.8,1.3,1.1c-2.1,2.2-2,5.7,0.3,7.8 c2.1,1.9,5.3,2,7.4,0.1c1.4,2.7,4.8,3.6,7.4,2.2c0.6-0.4,1.2-0.8,1.7-1.4c2.5,1.8,5.9,1.3,7.7-1.2c1.8-2.5,1.3-5.9-1.2-7.7 c-1-0.7-2.1-1.1-3.3-1.1c-0.7,0-1.5,0.1-2.2,0.4c0.8-1,1.2-2.2,1.2-3.4c0-2.4-1.5-4.5-3.8-5.2c1.3-1.1,2.1-2.6,2.1-4.3 c0-0.4,0-0.8-0.1-1.2c2.9-1.1,4.3-4.3,3.2-7.2c-0.5-1.4-1.6-2.5-3-3.1c2.4-1.9,2.8-5.3,1-7.7c0,0-0.1-0.1-0.1-0.1 C96.9,140.5,97.7,139.8,98.3,138.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M133.5,336.8c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9h0 C128.6,325.8,133.5,330.7,133.5,336.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M114.9,348.5c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9 C110,337.5,114.9,342.4,114.9,348.5C114.9,348.5,114.9,348.5,114.9,348.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M95.2,359.6c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9h0 C90.3,348.7,95.2,353.6,95.2,359.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M258.7,370.7c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9 C253.8,359.8,258.7,364.7,258.7,370.7L258.7,370.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M250.7,356.1c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9h0 C245.8,345.2,250.7,350.1,250.7,356.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M232.2,353.4c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9 S232.2,347.3,232.2,353.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M239.9,336.9c0,6-4.9,10.9-10.9,11c-6,0-10.9-4.9-11-10.9c0-6,4.9-10.9,10.9-11c0,0,0,0,0,0 C235,326,239.9,330.9,239.9,336.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M252.8,331.4c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9 C247.9,320.5,252.8,325.4,252.8,331.4C252.8,331.4,252.8,331.4,252.8,331.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M219.8,308.3c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9 S219.8,302.3,219.8,308.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M239.7,295.6c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9h0 C234.8,284.6,239.7,289.5,239.7,295.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M264.9,267.6c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9 C260,256.6,264.9,261.5,264.9,267.6C264.9,267.6,264.9,267.6,264.9,267.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M248.2,275.7c0,6-4.9,10.9-10.9,11s-10.9-4.9-10.9-10.9s4.9-10.9,10.9-11c0,0,0,0,0,0 C243.3,264.8,248.2,269.7,248.2,275.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M223.1,277.8c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9h0 C218.2,266.9,223.1,271.8,223.1,277.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M205.3,291c0,6-5,10.9-11,10.9s-10.9-5-10.9-11c0-6,4.9-10.9,10.9-10.9C200.4,280,205.3,284.9,205.3,291 C205.3,291,205.3,291,205.3,291"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M264.2,143c0,6-5,10.9-11,10.9c-6,0-10.9-5-10.9-11c0-6,4.9-10.9,10.9-10.9C259.3,132,264.2,136.9,264.2,143 C264.2,143,264.2,143,264.2,143"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M263.3,168.4c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9c0,0,0,0,0,0 C258.4,157.4,263.3,162.3,263.3,168.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M261.2,197.8c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9S261.2,191.7,261.2,197.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M259,219.6c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9h0 C254.1,208.7,259,213.6,259,219.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M252.5,253.7c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9 S252.5,247.7,252.5,253.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M256.4,236c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9h0 C251.5,225.1,256.4,230,256.4,236"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M206.9,20.6c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9S190,9.7,196,9.7c0,0,0,0,0,0 C202,9.7,206.9,14.6,206.9,20.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M218.4,43.5c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9s4.9-10.9,10.9-10.9l0,0 C213.5,32.6,218.4,37.5,218.4,43.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M252.8,102.3c0,6-4.9,10.9-10.9,10.9s-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9 C247.9,91.3,252.8,96.2,252.8,102.3C252.8,102.3,252.8,102.3,252.8,102.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M261.3,121.4c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9c0-6,4.9-10.9,10.9-10.9l0,0 C256.4,110.4,261.3,115.3,261.3,121.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M92.2,24.2c0,3.9-3.1,7-7,7s-7-3.1-7-7s3.1-7,7-7S92.2,20.4,92.2,24.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M116.3,17.1c0,3.9-3.1,7-7,7s-7-3.1-7-7s3.1-7,7-7S116.3,13.3,116.3,17.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik8);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_8.117537de86df93051ec164f044cad4e4.svg";
export { ForwardRef as ReactComponent };